import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { InjectionToken, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core';
import { ApolloLink, concat } from '@apollo/client/link/core';
import { Loader } from '@googlemaps/js-api-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { authMiddleware } from 'graphql-client';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { AccountsComponent } from './accounts/accounts.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { ErrorPageComponent } from './error-page/error-page.component';
import { FinalSuccessResponseComponent } from './final-success-response/final-success-response.component';
import { FooterComponent } from './footer/footer.component';
import { IdentificationComponent } from './identification/identification.component';
import { IncomeComponent } from './income/income.component';
import { MainContainerComponent } from './main-container/main-container.component';
import { MarketingContentComponent } from './marketing-content/marketing-content.component';
import { PersonalComponent } from './personal/personal.component';
import { ProductTermsComponent } from './product-terms/product-terms.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ResidenceComponent } from './residence/residence.component';
import { AWSService } from './services/aws.service';
import { AppPasswordDirective } from './shared/directives/app-password.directive';
import { TwoDigitDecimaNumberDirective } from './shared/directives/app-two-digit-decimal-number.directive';
import { OnlyAlphabetsDirective } from './shared/directives/only-alphabets.directive';
import { StreetAddressDirective } from './shared/directives/street-address.directive';
import { PhoneFormatPipe } from './shared/pipes/phone-format.pipe';
import { SafeHtmlPipe } from './shared/pipes/safe-html.pipe';
import { SuccessPrequalComponent } from './success-prequal/success-prequal.component';
import { SummaryComponent } from './summary/summary.component';

// TODO: Remove
export const APP_CONFIG = new InjectionToken<any>('app.config');

@NgModule({
  declarations: [
    AppComponent,
    PersonalComponent,
    OnlyAlphabetsDirective,
    StreetAddressDirective,
    ResidenceComponent,
    IdentificationComponent,
    ProgressBarComponent,
    IncomeComponent,
    MainContainerComponent,
    AccountsComponent,
    TwoDigitDecimaNumberDirective,
    AppPasswordDirective,
    IdentificationComponent,
    ErrorPageComponent,
    SummaryComponent,
    FinalSuccessResponseComponent,
    SuccessPrequalComponent,
    SafeHtmlPipe,
    PhoneFormatPipe,
    FooterComponent,
    ProductTermsComponent,
    MarketingContentComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule.forRoot([]),
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxMaskDirective,
    NgxGpAutocompleteModule,
    ApolloModule,
    NgbModule,
  ],
  providers: [
    CurrencyPipe,
    PhoneFormatPipe,
    {
      provide: APOLLO_OPTIONS,
      useFactory(httpLink: HttpLink) {
        const http = httpLink.create({
          uri: prequalConfig?.GRAPHQL_URI || '',
        }) as unknown as ApolloLink;
        return {
          connectToDevTools: true,
          cache: new InMemoryCache(),
          link: concat(authMiddleware, http),
        } as unknown as ApolloClientOptions<any>;
      },
      deps: [HttpLink],
    },
    // TODO: Remove and see if other resources tied to this can be removed as well
    // { provide: APP_CONFIG, useValue: appConfig },
    AWSService,
    provideNgxMask(),
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: (prequalConfig?.GOOGLE_MAPS_API_KEY as unknown as string) || '',
        libraries: ['places'],
      }),
    },
  ],
  bootstrap: [AppComponent],
  exports: [SafeHtmlPipe],
})
export class AppModule {}
